import { Link } from "react-router-dom";

/**
 * TradeMind-Logo in drei Varianten.
 * Die PNGs haben einen dunklen Navy-Hintergrund — `mix-blend-mode: screen`
 * lässt diesen Hintergrund gegen dunkle App-Flächen verschwinden.
 */
const VARIANTS = {
  icon: { src: "/brand/logo-icon.png", alt: "TradeMind" },
  name: { src: "/brand/logo-name.png", alt: "TradeMind" },
  full: { src: "/brand/logo-full.png", alt: "TradeMind — Reflektieren. Verstehen. Verbessern." },
};

export default function Logo({
  variant = "name",
  className = "",
  imgClassName = "",
  to = null,
  height,
  blend = false,
  testid,
}) {
  const v = VARIANTS[variant] || VARIANTS.name;
  const style = height ? { height, width: "auto" } : undefined;
  const img = (
    <img
      src={v.src}
      alt={v.alt}
      style={style}
      className={`${blend ? "mix-blend-screen" : ""} ${imgClassName}`}
      data-testid={testid || `logo-${variant}`}
      draggable={false}
    />
  );
  if (to) {
    return (
      <Link to={to} className={`inline-flex items-center ${className}`}>
        {img}
      </Link>
    );
  }
  return <div className={`inline-flex items-center ${className}`}>{img}</div>;
}
